import Link from "next/link";
import { useEffect, useState } from "react";

type Customer = {
  rel: string;
  img_alt: string;
  img_link: string;
  business: string;
  review: string;
  name: string;
};

type CustomerStoriesProps = {
  data: {
    currentPageCustomerName: string;
    customers: Customer[];
    heading: string;
  };
};

export default function CustomerStories({ data }: CustomerStoriesProps) {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const currentCustomerPage = data.currentPageCustomerName;
  let customers: Customer[] = data.customers;

  useEffect(() => {
    setIsPageLoaded(true);
  }, []);

  function shuffle(e: Customer[]) {
    for (let t = e.length - 1; t > 0; t--) {
      let a = Math.floor(Math.random() * (t + 1));
      [e[t], e[a]] = [e[a], e[t]];
    }
  }

  function filterCustomerDetails() {
    return customers.filter((page) => {
      return page.name !== currentCustomerPage;
    });
  }

  const RandomCustomerList = () => {
    customers = filterCustomerDetails();
    shuffle(customers);
    customers = customers.slice(0, 3);

    return (
      <>
        {customers.map((customer, count) => (
          <Link
            href={customer.rel}
            key={count}
            prefetch={false}
            className="customer-story btn-outline px-0 py-0"
          >
            <figure>
              <picture>
                <img
                  alt={customer.img_alt}
                  src={`${customer.img_link}@2x.png`}
                  height="172"
                  className="br-4"
                  loading="lazy"
                />
              </picture>
            </figure>
            <div className="md:pb-4 md:pl-3 md:pr-3 md:pt-3 lg:pb-4 lg:pl-3 lg:pr-3 lg:pt-3 lg:text-left md:text-left">
              <p className="lg:mb-2 md:mb-2 customer-business">
                {customer.business}
              </p>
              <span className="apostrophe text-brandcolor lg:mb-1 md:mb-1">
                “
              </span>
              <blockquote className="fw-700">{customer.review}</blockquote>
            </div>
          </Link>
        ))}
      </>
    );
  };

  return (
    <section className="bg-light lg:pt-20 lg:pb-15 md:pt-10 md:pb-10 customer-info-section">
      <h2
        className="container lg:text-center md:text-left lg:mb-4 md:mb-2 text-xl md:text-mds"
        dangerouslySetInnerHTML={{ __html: data.heading }}
      />
      <div
        className="container card--default card--feature has-three-col lg:mt-10 md:mt-5"
        id="customerInfoContainer"
      >
        {isPageLoaded && <RandomCustomerList />}
      </div>
    </section>
  );
}
